import {LearnerLearningReminderFrequency} from '../../../types/LearnerLearningReminderFrequency';

export class UpdateLearningReminderRequestDto {
    constructor(
        public learningReminder: boolean | undefined,
        public learningReminderFrequency: LearnerLearningReminderFrequency | undefined
    ) {}
}
